(() => {
  const sliders = new Map();
  const carouselQuery = window.matchMedia('(max-width: 1007px)');

  const mountSlider = (container) => {
    if (!window.Splide || sliders.has(container)) return;

    const sliderElement = container.querySelector('.splide');
    if (!sliderElement) return;

    const slideCount = sliderElement.querySelectorAll('.splide__slide').length;
    if (slideCount === 0) return;

    const splide = new Splide(sliderElement, {
      type: slideCount > 1 ? 'loop' : 'slide',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: slideCount > 1,
      speed: 600,
      easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      drag: slideCount > 1,
      flickPowerThreshold: 8,
      keyboard: 'focused',
      trimSpace: true,
    });

    splide.mount();
    sliders.set(container, splide);
  };

  const destroySlider = (container) => {
    const splide = sliders.get(container);
    if (!splide) return;

    splide.destroy(true);
    sliders.delete(container);
  };

  const syncContainer = (container) => {
    if (container.dataset.stackOnMobile === 'true') {
      destroySlider(container);
      return;
    }

    if (carouselQuery.matches) {
      mountSlider(container);
    } else {
      destroySlider(container);
    }
  };

  const syncAll = (scope = document) => {
    scope.querySelectorAll('[data-collection-list-custom]').forEach(syncContainer);
  };

  document.addEventListener('DOMContentLoaded', () => syncAll());

  document.addEventListener('shopify:section:load', (event) => {
    syncAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-collection-list-custom]').forEach(destroySlider);
  });

  carouselQuery.addEventListener('change', () => syncAll());
})();
